import { api } from "./api";

const register = (input) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/register'}, input);
}
const login = (input) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/login', no_popup_msg: true}, input);
}
const sendResetPasswordLink = (input) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/send-reset-password-link'}, input);
}
const resetPassword = (input) => {
  return api({method: 'POST', url: process.env.REACT_APP_API_URL+'/reset-password'}, input);
}

export const authService = {
  register,
  login,
  sendResetPasswordLink,
  resetPassword
};